import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { CatalogueV2Model, IsCompliantModel, NewsletterInfo, NewsLetterV2 } from '../../models/catalogue-view.model';
import { FileService } from '../../services/file.service';
import { CommonService } from '../../services/common.service';
import { NgModel } from '@angular/forms';
import { SharedSingleSelectionPipe } from '../../shared/single-selection.pipe';
import { ApiResponse } from '../../models/api-response.model';

import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { AuthService } from '../../services/auth.service';
import { fromEvent } from 'rxjs';
import { filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { NewsletterService } from '../../services/newsletter.service';
import { NewsletterDeleteSectionComponent } from '../../popup-collection/newsletter-delete-section/newsletter-delete-section.component';

const LARGETOPWIDTH = "620%";
const UNSETTOPWIDTH = null;

@Component({
  selector: 'app-catalogue-edit-v2',
  templateUrl: './catalogue-edit-v2.component.html',
  styleUrls: ['./catalogue-edit-v2.component.css']
})
export class CatalogueEditV2Component implements OnInit {

  title = 'Catalogues';

  accountId: string;
  Catalogue: CatalogueV2Model;
  newsLetters: NewsLetterV2[];
  sortedData: NewsLetterV2[];
  cataloguecollection$: Subscription;
  closesub$: Subscription;
  selectedBrands = [];
  catalogueFilterValue = '';
  allBrandsItem: any[];
  uniqueBrands: string[];
  fixedUniqueBrands: string[];
  newsletterMsg: string;
  closeResult: string;
  switchMsg: string = "Edit";

  iconCanbeActive: boolean = false;
  hasAutoDeselected: boolean = false;
  hasEmptyResult: boolean = false;
  hasFilterChanged: boolean = false;
  loadContent: boolean = false;
  finishLoading: boolean = true;
  currentUserModel: CurrentUserModel;
  filterResultArr = undefined;

  brands: string[] = [];

  ngUnsubscribe: Subject<void> = new Subject<void>();
  refreshCatalogue: Subject<void> = new Subject<void>();
  refreshCatalogue$: Observable<CatalogueV2Model>;
  toplevelWidth = UNSETTOPWIDTH;
  changeNewsLetterType$: Subject<{ id: any, published: any }> = new Subject<{ id: any, published: any }>();

  @ViewChild('popover') public popover: NgbPopover;
  @ViewChild('allSelected', {static: true}) private allSelected: MatOption;
  @ViewChild('brandSelect') private brandSelect: NgModel;
  @ViewChild('matSelect') private matSelect: MatSelect;
  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent; //reference to the breadcrumb
  @ViewChild('filterInput') private _inputElement: ElementRef;

  // newsletterViewLoaded: boolean = false;

  constructor(
      private router: Router,
      private newsletterService: NewsletterService,
      private fileService: FileService,
      private commonService: CommonService,
      private authService: AuthService,
      private activeRouter: ActivatedRoute,
      private dialog: MatDialog,
  ) { 
      console.log(this.router.url)
      this.toplevelWidth = this.router.url.includes("newsletter") ? LARGETOPWIDTH : UNSETTOPWIDTH;
  }

  ngOnInit() {
      this.loadContent = false;

      this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: CurrentUserModel) => {
  
          this.currentUserModel = res;

          this.accountId = this.currentUserModel.accountId;
          //prevent access via url
          if(res.hideSOH) {
          this.router.navigateByUrl('/home');
          }
      },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((res: NavigationEnd) => {
          // $('.child-loader').animate({ scrollLeft: -$('#cataloguelist').width() }, 400);
          this.breadcrumbRef.ngAfterViewInit();
          this.toplevelWidth = res.url.includes("newsletter") ? LARGETOPWIDTH : UNSETTOPWIDTH;
      });

      this.refreshCatalogue$ = this.refreshCatalogue.pipe(switchMap(_ => {
          this.brands = [];
          this.fixedUniqueBrands =[];
          return this.newsletterService.getAllCatalogues().pipe(takeUntil(this.ngUnsubscribe),map((data: CatalogueV2Model) => {
            this.Catalogue = data;
            this.newsLetters = this.Catalogue.newsLetters;
            this.sortedData = this.Catalogue.newsLetters;

            //Get all brand value returning from API call
            this.newsLetters.forEach((data: NewsLetterV2) => {
                this.brands.push(data.brand);
            });
            //Get unique brand value 
            this.uniqueBrands = this.brands.filter((x, i, a) => x && a.indexOf(x) === i);
            this.fixedUniqueBrands = this.brands.filter((x, i, a) => x && a.indexOf(x) === i);
            this.loadContent = true;
            return data;
          }));
      }));
      this.refreshCatalogue$.subscribe();
      this.refreshCatalogue.next();

      this.changeNewsLetterType$.asObservable().pipe(
          tap(() => { this.loadContent = false }),
          switchMap((newsletter) => {
              return this.newsletterService.updateNewsletterPublishSQL(newsletter.id, newsletter.published)
          })
      ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
          this.loadContent = true;
      });

      this.filterResultArr = new SharedSingleSelectionPipe().transform(this.newsLetters, this.catalogueFilterValue, this.selectedBrands, this.allSelected.selected, 'catalogues');
      if (this.filterResultArr === []) {
          this.hasEmptyResult = true;
      }

      this.newsletterService.currentEditNewsletterWatch.subscribe((res => {
          if(!this.commonService.isEmpty(res)) {
              this.refreshCatalogue.next();
          }    
      }))
  }

  ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
      // if (this.cataloguecollection$) {
      //     this.cataloguecollection$.unsubscribe();
      // }
  }

  ngAfterViewInit() {
      fromEvent(document.querySelector("#newNewsletter"), "click").pipe(
          tap(() => { this.loadContent = false }),
          switchMap(() => this.newsletterService.createNewNewsletter())
      ).pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((res: NewsletterInfo) => {
              this.loadContent = true;
              this.router.navigateByUrl('/catalogueedit/editnewsletter/' + res.news_id);
          });
  }

  onAddNewsletter() {
      this.loadContent = false;
      this.newsletterService.createNewNewsletter().pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((res: NewsletterInfo) => {
              this.refreshCatalogue.next();
              this.loadContent = true;
              this.router.navigateByUrl('/catalogueedit/editnewsletter/' + res.news_id);
      });
  }

  navigateTo(url: string) {
      this.router.navigate([url]);
  }

  onMenuDownload(menu: string) {
      if(menu == "Download All to Excel") {
          this.sendAllNewslettersFn();
      } else if (menu == "Download CSV") {
          this.downloadCSV();
      }
  }

  onChange() {
      if (this.catalogueFilterValue.length > 0) {
          this.hasFilterChanged = true;
      } else {
          this.hasFilterChanged = false;
      }
      this.filterResultArr = new SharedSingleSelectionPipe().transform(this.newsLetters, this.catalogueFilterValue, this.selectedBrands, this.allSelected.selected, 'catalogues');
      if (this.filterResultArr === []) {
          this.hasEmptyResult = true;

      } else {
          this.hasEmptyResult = false;
      }
  }

  dateFormat(item: NewsLetterV2) {
      let date = item.mdate.slice(8, 10);
      let month = item.mdate.slice(5, 7);
      let year = item.mdate.slice(0, 4);
      let newDateFormat = `${date}/${month}/${year}`
      return newDateFormat;
      // return newDateFormat.getUTCDate();
  }

  openedChange(opened: boolean) {
      if (!opened) {
          if (this.allSelected.selected) {
              this.brandSelect.update.emit([]);
          }
      }
  }

  openPop(): void {
      this.popover.isOpen() ? this.popover.close() : this.popover.open();
      this.popover.isOpen() ? this.iconCanbeActive = true : this.iconCanbeActive = false;
  }

  filterReset(): void {
      // this.selectedBrands = [];
      this.catalogueFilterValue = '';
      this.hasEmptyResult = false;
      if (!this.uniqueBrands.includes('all')) {
          this.uniqueBrands.push('all');
      }
      this.brandSelect.update.emit([]);
      this._inputElement.nativeElement.focus();
  }

  popOpen(p: NgbPopover): void {
      p.open();
  }

  //called when All option is clicked
  toggleAllSelection(selectedBrands: NgModel) {
      //Condition 1: every option (include 'All') is selected and click the All option
      if (this.selectedBrands.length === this.uniqueBrands.length - 1) {
          console.log('condition one');
          selectedBrands.update.emit([]);
      }
      //Condition 2: All option is deselected and at least one other option is selected
      else if (this.hasAutoDeselected && !this.allSelected.selected) {
          console.log('condition two');
          if (!this.uniqueBrands.includes('all')) {
              this.uniqueBrands.push('all');
          }
          selectedBrands.update.emit(this.uniqueBrands);
      }
      //Condition 3: All option is auto selected, and every option is selected. 
      else if (this.selectedBrands.length === this.uniqueBrands.length && this.selectedBrands.length > 0 && this.allSelected.selected) {
          console.log('condition three');
          selectedBrands.update.emit([]);
      }

      //Condition 4: None of options are selected and click the All option
      else if (this.allSelected.selected) {
          console.log('condition four');
          if (!this.uniqueBrands.includes('all')) {
              this.uniqueBrands.push('all');
          }
          selectedBrands.update.emit(this.uniqueBrands);
      }
      // else{
      //   console.log('condition 4');
      //   selectedBrands.update.emit([]);
      // }
  }

  tickAllOptionsByOpeningPanel(event) {
      //check if the panel is opened
      if ($(event.target).closest('.mat-input-flex.mat-form-field-flex').length) {
          if (!this.uniqueBrands.includes('all')) {
              this.uniqueBrands.push('all');
          }
          if (this.selectedBrands.length === 0) {
              this.brandSelect.update.emit(this.uniqueBrands);
          }
      }
  }

  //called when the mat-select has any changes.
  updateBrandList(brandSelect: NgModel) {
      //if All option is selected, but user deselect any other option -> All options will be deselected by default. 
      if ((this.selectedBrands.length < this.uniqueBrands.length) && this.allSelected.selected && this.selectedBrands.length != 1) {
          this.allSelected.deselect();
          this.hasAutoDeselected = true;
      }
      //if All option is deselected, but the rest options are selected. 
      if ((this.selectedBrands.length === (this.uniqueBrands.length - 1)) && !this.selectedBrands.includes('all')) {
          this.allSelected.select();
      }
  }

  exportExcelForCatalogue(newsId: string): void {

      this.finishLoading = false;

      this.newsletterService.exportExcelForCatalogueSQL(newsId).subscribe((data: any) => {

          const fileName = `Dicker Data Catalogue ${newsId}.xlsx`;

          this.fileService.saveAsExcelFile(data, fileName);
          this.finishLoading = true;

      },
          (error: any) => {
              console.info(error);
              this.finishLoading = true;
          });
  }

  sendAllNewsletters(billTo: string, content, event): void {

      this.loadContent = false;

      event.preventDefault();
      event.stopPropagation();

      this.sendAllNewslettersFn();

      // setTimeout(() => {
      //   $('#sendNewsletterPopup').foundation('close');
      // }, 2000);
  }

  sendAllNewslettersFn(){
      this.newsletterService.sendAllNewsletters(this.accountId).subscribe((res: any) => {
          this.newsletterMsg = "";
          if (res.status) {
              if (res.responseMessage == "added") {
                  // this.newsletterMsg = "The latest copy of the Dicker Data pricelist is being generated and emailed to you. It may take up to 15 minutes for you to receive this email";
                  this.commonService.implementToast('The latest copy of the Dicker Data pricelist is being generated and emailed to you. It may take up to 15 minutes for you to receive this email', 'Success')
              }
              else if (res.responseMessage == "queue") {
                  // this.newsletterMsg = "Your copy of the Dicker Data pricelist is in email queue. It may take up to 15 minutes for you to receive this email.";
                  this.commonService.implementToast('Your copy of the Dicker Data pricelist is in email queue. It may take up to 15 minutes for you to receive this email.', 'Success')
              }
              else if (res.responseMessage == "noemail") {
                  // this.newsletterMsg = "Please update your email in the profile section and try again.";
                  this.commonService.implementToast('Please update your email in the profile section and try again.', 'Error')

              }
              else if (res.responseMessage == "noaccount") {
                  // this.newsletterMsg = "Not a valid account.";
                  this.commonService.implementToast('Not a valid account.', 'Error')
              }
              this.loadContent = true;


              if (this.popover.isOpen()) {
                  $("#editDownloadButton").click();
              }
          }
      },
          (error: any) => {
              console.info(error);
              this.loadContent = true;
          });
  }

  downloadCSV(): void {
      if (this.Catalogue.dataFeedCSV) {
          this.commonService.implementToast('Datafeeds CSV will be downloaded shortly', 'Success')
      }
      else {
          this.commonService.implementToast('Download Datafeeds CSV failed', 'Error');
      }

      if (this.popover.isOpen()) {
          $("#editDownloadButton").click();
      }
  }

  closeDownload(): void {
      this.popover.close();
      this.iconCanbeActive = false;
  }
  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
  }

  goToNewsletterView(newsId: string): void {
      if (this.breadcrumbRef) {
          this.breadcrumbRef.ngAfterViewInit();//recreate breadcrumb
      }
  }

  switchCatalogueMode(): void {
      this.router.navigateByUrl("/catalogues");
  }

  close() {
      this.loadContent = true;
      this.router.navigateByUrl('/catalogues');
  }

  sortData(sort: Sort) {
      const data = this.newsLetters.slice();
      if (!sort.active || sort.direction == '') {
          this.sortedData = data;
      }

      this.sortedData = data.sort((a, b) => {
          let isAsc = sort.direction == 'asc';
          switch (sort.active) {
              case 'brand': return compare(a.brand, b.brand, isAsc);
              case 'dateModified': return compare(a.mdate.split('-').reverse().join('-'), b.mdate.split('-').reverse().join('-'), isAsc);
              default: return 0;
          }
      });
  }

  changeType(event: any, item: any) {
    // need to add full changelist of things that are required to have a newsletter published
    // a min of 50 and maximum 220 item limit and a minimum of 2 promotion items per newsletter
    this.newsletterService.isNewsletterCompliant(item.news_id).subscribe((res: IsCompliantModel) => {
        var idx = this.Catalogue.newsLetters.findIndex(x => x.news_id === item.news_id);
        this.Catalogue.newsLetters[idx].isCompliant = res;
        if (res.isCompliant == true) {
            if (item.brand && item.description) {
                if (event.target.checked === false) {
                    item.published = '1';
                } else {
                    item.published = '0';
                }

                this.changeNewsLetterType$.next({ id: item.news_id, published: item.published });
            } else {
                event.target.checked = false;
                this.commonService.implementToast(item.id + ' Can not be published without brand and descripton', 'Error');

            }
        } else {
            // need to check if the newsletter was already published so that it updates to being unpublished
            // new 
            if (event.target.checked == false) {
                this.changeNewsLetterType$.next({ id: item.news_id, published: '1'});
            } else {
                this.commonService.implementToast(item.news_id.toString() + ' Newsletter cannot be published as it does not meet the minimum criteria. ' + res.errorMessage, 'Error');
                event.target.checked = false;
            }

        }
    });
  }

  deleteNewsletter(newsId: string): void {    
    const dialogRef = this.dialog.open(NewsletterDeleteSectionComponent, {
        width: '500px',
        panelClass: 'mat-dialog-wrapper',
        data: { type: "newsletter" }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.newsletterService.deleteNewsletter(newsId).subscribe((res: ApiResponse) => {
                if (res.status) {
                    this.loadContent = false;
                    this.newsletterService.getAllCatalogues().subscribe((data: CatalogueV2Model) => {
                        this.Catalogue = data;
                        this.newsLetters = this.Catalogue.newsLetters;
                        this.sortedData = this.Catalogue.newsLetters;
                        //Get all brand value returning from API call
                        this.newsLetters.forEach((data: NewsLetterV2) => {
                            this.brands.push(data.brand);
                        });
                        //Get unique brand value 
                        this.uniqueBrands = this.brands.filter((x, i, a) => x && a.indexOf(x) === i);
                        this.fixedUniqueBrands = this.brands.filter((x, i, a) => x && a.indexOf(x) === i);
                        this.loadContent = true;
                    },
                        (error: any) => {
                            console.info(error);
                            this.loadContent = true;
                        });
                }
            },
                (error: any) => {
                    console.error(error);
                    this.loadContent = true;
                });  
        }
      });
  }

  onLoading(currentLoadingStatus: boolean) {
      this.loadContent = !currentLoadingStatus;
  }

  getActiveStockCount(item: any) {
    this.newsletterService.isNewsletterCompliant(item.news_id).subscribe((res: IsCompliantModel) => {
        var idx = this.Catalogue.newsLetters.findIndex(x => x.news_id === item.news_id);
        this.Catalogue.newsLetters[idx].isCompliant = res;
    });
  }

  get isDev() {
    return this.commonService.getIsDevOps();
  }


}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
